<template id="child">
<div v-if="showModal" :style="cssProps">
    <div class="modal d-flex flex-column" v-if="product.id">
       <div class="d-flex flex-row justify-content-between">
           <div class="title d-flex flex-column">
               <h1>{{product.name}}</h1>
                <span v-if="product.basecalories">{{product.basecalories}} Calories</span>
           </div>
            <h1>${{product.cost}}</h1>
       </div>
       <span class="description">{{product.description}}</span>
       <div class="quantity d-flex flex-row justify-content-between align-items-center">
           <span>Quantity</span>
           <div class="btn-quant d-flex justify-content-around flex-row align-items-center">
               <button @click="minusQuantity">Less</button>
               <span>{{quantity}}</span>
               <button @click="plusQuantity">More</button>
           </div>
       </div>
       <div class="option d-flex flex-row justify-content-between" v-if="optionGroups.length >= 1">
           <span>Options</span>
           <span>Requered</span>
       </div>
	   <div class="topping d-flex" v-if="optionGroups.length >= 1">
          <span>{{optionGroups[0].description}}</span>
        </div>
       <!-- <div class="btn-option d-flex flex-row justify-content-between" v-if="optionGroups[0]">
           <button class="d-flex flex-row align-items-center justify-content-around" v-for="option in optionGroups[0].options" :key="option.id">
               <i class="fas fa-check-circle"></i>
               <div class="d-flex flex-column">
                   <span>{{option.name}}</span>
                   <span>Single - 620 Calories </span>  
               </div>
               <i class="fas fa-caret-down"></i>
           </button>
           
       </div> -->
	   <div class="btn-option" v-if="optionGroups.length >= 1">
		   <button class="d-flex flex-row align-items-center justify-content-around" v-for="option in optionGroups[0].options" :key="option.id" @click="addOptionFirst(option.id)" :class="isActive(option.id)? 'active' : ''">
			    <i :class="isActive(option.id)? 'fas fa-check-circle' : 'fal fa-circle'"></i>
				<div class="d-flex flex-column">
					<span>{{option.name}}</span> 
				</div>
				<i class="fas fa-caret-down"></i>
		   </button>
	   </div> 
       
        <!-- <div class="topping d-flex" >
          <span>Toppings</span>
        </div> -->
        <div class="btn-topping d-flex" v-if="optionGroups.length >= 2">
            
            <button class="d-flex flex-row justify-content-between align-items-center">
                <div class="d-flex flex-row align-items-center">  
                    <i class="fal fa-circle"></i>
                    <span>{{optionGroups[1].description}}</span>
                </div>
                
                <i class="far fa-angle-right"></i>
            </button>
        </div>
		<div class="btn-topping d-flex" v-if="optionGroups.length >= 3">
            
            <button class="d-flex flex-row justify-content-between align-items-center">
                <div class="d-flex flex-row align-items-center">  
                    <i class="fal fa-circle"></i>
                    <span>{{optionGroups[2].description}}</span>
                </div>
                
                <i class="far fa-angle-right"></i>
            </button>
        </div>
        <!-- <div class="special d-flex">
            <span>Special Instructions</span>
        </div>
        <div class="special-input d-flex">
            <input type="text" placeholder="Please, no price altering substitutions/additions">
        </div> -->
        <div class="button d-flex flex-row justify-content-between">
                <button @click="hide">
                    <span>Cancel</span>
                </button>
                <button @click="save">
                    <span>Add To Basket</span>
                </button>
            </div>
    </div>
    <div class="modal-overlay"></div>
</div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
    template: '#child',
    data(){
        return{
        	showModal: false,
			product: {},
			productToBasket: {
				productid: null,
				quantity: 1,
				choices: [],
				specialinstructions: null
			},
			quantity: 1,
			optionGroups: [],
        }
	},
	computed: {
		...mapState(["info"]),
		cssProps() { return {
        '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
      }
    }
	},
    methods: {
        show(product) {
			this.showModal = true;
			if(product){ 
				this.product = product;
				this.quantity = 1;
				this.productToBasket.productid = this.product.id;
				this.productToBasket.quantity = 1;
				// this.productToBasket.options = "";
				this.productToBasket.choices = [];
				this.productToBasket.specialinstructions = null;
				this.getModifiers(this.product.id);
			}
        },
        hide(){
            this.showModal = false;
        },
       	getModifiers(id){
			axios.get(`https://secure-badlands-41449.herokuapp.com/products/${id}/modifiers?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP`)
			.then(response => {
				this.optionGroups = response.data.optiongroups;
				console.log(response.data);
			})
		},
		save(){
			this.$store.commit('product.add', {product: {quantity: this.quantity, product: this.product}});
			this.$store.commit('sum.add', {sum: this.quantity * this.product.cost});
			this.hide();
		},
		plusQuantity(){
			this.quantity++;
			this.product.quantity++;
		},
		minusQuantity(){
			this.quantity > 1 ? this.quantity--: this.quantity;
			this.product.quantity > 1 ? this.product.quantity--: this.product.quantity;
		},
		addOptionFirst(optionid){
			// if(this.optionGroups[0].maxselects === 1 || !this.optionGroups[0].maxselects){
			// 	this.optionGroups[0].options.forEach(option => {
			// 		if(this.productToBasket.options.includes(option.id)){
			// 			this.productToBasket.options = this.productToBasket.options.replace(option.id + ",", "");
			// 		}
			// 	})
			// }
			// this.productToBasket.options += optionid + ",";
			// console.log(this.productToBasket.options)
			if(!this.isActive(optionid)){
				this.productToBasket.choices.push({choiceid: optionid})
			}
			
			console.log(this.productToBasket)
		},
		isActive(optionid){
			let active = false;
			// return this.productToBasket.options.includes(optionid);
			this.productToBasket.choices.forEach(choice => {
				if(choice.choiceid === optionid){
					active = true;
				}
			})
			return active;
		},

    },
    mounted(){
		//load from vuex
    }
}
</script>
<style scoped>
.active{
	border-color: var(--main-color) !important;
}
button
{
    border: none;
}
.button
{
    padding-top: 36px;
    width: 100%;
}

.button button:first-child 
{
  

	height: 48px;
	width: 160px;
	border: 1px solid var(--main-color);
	border-radius: 24px;
	background-color: #FFFFFF;

}
.button button:first-child span{
   
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	text-align: center;
}
.button button:last-child
{
	height: 48px;
    width: 306px;
	border-radius: 24px;
	background-color: var(--main-color);
}
.button button:last-child span{
    
	color: #FFFFFF;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
	

}
input
{
    border:none;
}
.special-input input
{
    width: 100%;
    box-shadow: 0 1px 0 0 rgba(0,0,0,0.2);
    height: 56px;
}
.special-input input::placeholder
{
   
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	
}

.special
{
    padding-top: 40px;
    width: 100%;
}
.special span{

	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 25px;
}
.btn-topping
{
        padding-top: 24px;

}
.btn-topping button span{
   
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: bold;
	line-height: 20px;
    padding-left: 16px

}
.btn-topping button i:first-child
{
    
	height: 14px;
	width: 24px;
	color:grey;
	font-family: "Font Awesome 5 Pro";
	font-size: 25px;
	line-height: 14px;
	text-align: center;
}

.btn-topping button i:last-child
{

	height: 24px;
	width: 9px;
	opacity: 0.8;
	color: #000000;
	font-family: "Font Awesome 5 Pro";
	font-size: 24px;
	font-weight: 300;
	line-height: 24px;
	text-align: center;

}
.btn-topping button
{

	height: 64px;
	width: 482px;
	border: 1px solid rgba(0,0,0,0.1);
	border-radius: 8px;
	background-color: #FFFFFF;
    padding: 20px

}
.topping span{

	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 25px;
    padding-top: 40px;
}



.btn-option button i{
    
    color: gray;
    font-size: 25px;
}
.btn-option
{
    padding-top: 24px;
    width: 100%;
	display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 5px;
}
.btn-option button
{   
   
	height: 64px;
	width: 237px;
    border-radius: 8px;
	border: 1px solid rgba(0,0,0,0.1);


}

.btn-option button span:first-child
{
    opacity: 1;
	color: #000000;
	font-family: Poppins;
	font-size: 14px;
	line-height: 20px;
    text-align: left;
    font-weight: bold;
}
.btn-option button span:last-child
{
     opacity: 0.6;
	color: #000000;
	font-family: Poppins;
	font-size: 10px;
	line-height: 20px;
    font-weight: 500;
}
.option span:last-child
{
 
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	line-height: 20px;
	text-align: right;
}

.option
{
    padding-top: 45px;
}
.option span:first-child{
    
	
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 25px;

}
.btn-quant
{
    width: 200px;
}
.btn-quant span{
 
	opacity: 0.6 !important;
	color: #000000;
	font-family: Poppins;
	font-size: 20px !important;
	font-weight: 300 !important;
	line-height: 30px !important;
	text-align: center;

}

.btn-quant button
{
   
	height: 48px;
	width: 80px;
	border: 1px solid var(--main-color);
	border-radius: 24px;
	background-color: #FFFFFF;

	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;

}
button
{ border: none;
  padding: 0;
  background: none;
  outline: none;
}
.quantity
{
    padding-top: 45px;
}
.quantity span
{
   
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 25px;
}

.description
{
    
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 15px;
	line-height: 23px;
    padding-top: 24px;
}
.modal {
  position: fixed;;
  left:0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  
  padding: 48px;
  box-sizing: border-box;
	
    z-index: 5;
   
	height: 822px;
	/* height: 380px; */
	width: 580px;
	border: 1px solid rgba(0,0,0,0.1);
	border-radius: 8px;
	background-color: #FFFFFF;
    
}
.modal h1
{
    
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 24px;
	font-weight: 800;
	line-height: 35px;   
}
.title h1
{
  
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 24px;
	font-weight: 800;
	line-height: 35px;

}
.title span{
    
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	line-height: 20px;

}

.modal-overlay
{
   position: fixed; 
  width: 100%; 
  height: 100%; 
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5); /* Black background with opacity */
  z-index: 1; 
}
@media screen and (max-width: 600px)
{
    .modal{
        width: 100%;
        padding: 22px;
        /* height: 100%; */
    }
	.description
	{
		font-size: 14px;
		padding: 0;
	}
	.quantity
	{
		/* padding-top: 20px; */
		/* padding-top: 75px; */
		padding-top: 25px !important;
	}
	.btn-option
	{
		padding-top: 15px;
	}
	.btn-option button
	{
		width: 50%;
	}
	.topping span
	{
		padding-top: 25px;
	}
	.special
	{
		padding-top: 10px;
	}
	.option
	{
		padding-top: 20px;
	}
	/* .button
	{
		padding-top: 80px
	} */
	.button
    {
        flex-direction: column-reverse !important;
        justify-content: center !important;
        align-items: center !important;

    }
    .button button:first-child
    {
        width: 100%;
        margin-top: 10px;
    }
    .button button:last-child
    {
        width: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/steps/modals/orderFirst.vue